__turbopack_context__.v({
  "box": "help-module-scss-module__BXb0Vq__box",
  "typography": "help-module-scss-module__BXb0Vq__typography",
});
